module.exports = __webpack_public_path__ + "img/jieshi_grey.45f8a30a.svg";